import {Injectable, Inject} from '@angular/core';
import {v1_breezeServiceName} from '@app/v1_integration';

/**
 * Provide Breeze feature.
 * Note: For now, we create this as a wrapper around V1 Breeze service.
 */
@Injectable()
export class BreezeService implements Pulse.Services.IBreezeService {
  breeze: any;

  constructor(
    @Inject(v1_breezeServiceName)
    private _v1Breeze: Pulse.Services.IBreezeService
  ) {
    this.breeze = this._v1Breeze.breeze;
  }

  getEntityManager(): breeze.EntityManager {
    return this._v1Breeze.getEntityManager();
  }
  getDCContextType(): Pulse.Services.DCContextType {
    return this._v1Breeze.getDCContextType();
  }
  setDCContextType(dcContextType: Pulse.Services.DCContextType): void {
    return this._v1Breeze.setDCContextType(dcContextType);
  }
  saveChanges(
    entities?: breeze.Entity[],
    config?: breeze.SaveOptionsConfiguration,
    callback?: breeze.SaveChangesSuccessCallback,
    errorCallback?: breeze.SaveChangesErrorCallback
  ): breeze.promises.IPromise<breeze.SaveResult> {
    return this._v1Breeze.saveChanges(
      entities,
      config,
      callback,
      errorCallback
    );
  }
}
